import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email) || form.message.trim().length < 5) {
      setStatus({ type: "error", msg: "Fill in your name, a valid email and a message." });
      return;
    }
    setLoading(true);
    try {
      await api.post("/contact", form);
      setStatus({ type: "ok", msg: "Message received. We reply within 1–2 business days." });
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus({ type: "error", msg: "Something went wrong. Try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="mx-auto max-w-7xl px-5 pb-24 pt-32 md:px-8 md:pt-40">
      <p className="font-tech text-[11px] tracking-[0.3em] text-ll-red">CONTACT</p>
      <h1 className="mt-2 font-display text-6xl tracking-wide md:text-8xl">TALK TO US</h1>

      <div className="mt-12 grid gap-16 md:grid-cols-2">
        <form onSubmit={submit} className="space-y-5" noValidate>
          <div>
            <label htmlFor="contact-name" className="font-tech text-[11px] tracking-[0.2em] text-ll-steel">NAME</label>
            <input id="contact-name" data-testid="contact-name-input" type="text" value={form.name}
                   onChange={(e) => setForm({ ...form, name: e.target.value })}
                   className="mt-1 w-full border border-ll-linestrong bg-ll-black px-4 py-3 text-sm outline-none transition-colors duration-200 focus:border-ll-red" />
          </div>
          <div>
            <label htmlFor="contact-email" className="font-tech text-[11px] tracking-[0.2em] text-ll-steel">EMAIL</label>
            <input id="contact-email" data-testid="contact-email-input" type="email" value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })}
                   className="mt-1 w-full border border-ll-linestrong bg-ll-black px-4 py-3 text-sm outline-none transition-colors duration-200 focus:border-ll-red" />
          </div>
          <div>
            <label htmlFor="contact-message" className="font-tech text-[11px] tracking-[0.2em] text-ll-steel">MESSAGE</label>
            <textarea id="contact-message" data-testid="contact-message-input" rows={5} value={form.message}
                      onChange={(e) => setForm({ ...form, message: e.target.value })}
                      className="mt-1 w-full border border-ll-linestrong bg-ll-black px-4 py-3 text-sm outline-none transition-colors duration-200 focus:border-ll-red" />
          </div>
          {status.msg && (
            <p data-testid="contact-status" className={`border px-3 py-2 text-xs ${status.type === "ok" ? "border-green-700 bg-green-900/20 text-green-400" : "border-ll-red/50 bg-ll-red/10 text-ll-red"}`}>
              {status.msg}
            </p>
          )}
          <motion.button data-testid="contact-submit-button" whileTap={{ scale: 0.98 }} type="submit" disabled={loading}
                         className="bg-ll-red px-10 py-4 font-tech text-sm tracking-[0.25em] transition-colors duration-200 hover:bg-ll-redhover disabled:opacity-60">
            {loading ? "SENDING…" : "SEND MESSAGE"}
          </motion.button>
        </form>

        <div className="space-y-8">
          <div>
            <p className="font-tech text-[11px] tracking-[0.25em] text-ll-steel">ORDER QUESTIONS</p>
            <p className="mt-2 text-sm text-ll-steel">
              Include your order number (starts with LL-) for the fastest reply. You can also check your order any time on the{" "}
              <Link to="/order-status" className="text-ll-red underline-offset-4 hover:underline">order status page</Link>.
            </p>
          </div>
          <div>
            <p className="font-tech text-[11px] tracking-[0.25em] text-ll-steel">ORDER QUESTIONS</p>
            <p className="mt-2 text-sm text-ll-steel">
              Read the <Link to="/policies/shipping-returns" className="text-ll-red underline-offset-4 hover:underline">shipping policy</Link> for shipping times, returns and exchanges.
            </p>
          </div>
          <div>
            <p className="font-tech text-[11px] tracking-[0.25em] text-ll-steel">SOCIAL</p>
            <div className="mt-2 flex gap-6">
              <a href="https://www.instagram.com/eternel" target="_blank" rel="noopener noreferrer" className="font-tech text-xs tracking-[0.2em] transition-colors duration-200 hover:text-ll-red">INSTAGRAM</a>
              <a href="https://www.tiktok.com/@eternel" target="_blank" rel="noopener noreferrer" className="font-tech text-xs tracking-[0.2em] transition-colors duration-200 hover:text-ll-red">TIKTOK</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
